import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
// Images
import BharatBillpay from "../Static/Images/bharat-billpay.png";
import ScratchCard from "../Static/Images/scratch-card.png";
import ScratchHalf from "../Static/Images/scratch-half.png";
import DoneIcon from "../Static/Images/success.gif";
import GooglePlay from "../Static/Images/google-play-logo.webp";
import Warning from "../Static/Images/warning.gif";

import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Slide from "@mui/material/Slide";
import { useGlobalContext } from "../context";
import { useHistory } from "react-router-dom";
import PeSpinner from "../Components/PeSpinner";
import swal from "sweetalert";
import BelowIcon from "../Components/BelowIcon";
import BillDetails from "../Components/BillDetails";
import {getBaseUrl} from "../API/getBaseUrl";
var fileDownload = require("js-file-download");

const TransitionUp = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DomainPayEmiProcessing = () => {
  const [billerInfo, setBillerInfo] = useState([]);
  const [loading, setLoading] = useState(true);
  // get data from localstorage

  const data = JSON.parse(localStorage.getItem("fetch_bill_data"));
  const userPaymentInfo = data?.payload;
  const amount = localStorage.getItem("amount");
  const [error, setError] = useState("");
  //  biller id
  const biller_id = userPaymentInfo?.map((data) => data.id);

  let history = useHistory();
  let count = 0;
  let ApiCount = 0;

  useEffect(() => {
    setInterval(() => {
      ApiCount = ApiCount + 1;
      if (ApiCount < 6) {
        fetch(`${getBaseUrl}getbilldetails/?bill_id=${biller_id}`, {
          method: "GET",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
        })
          .then((res) => res.json())
          .then((data) => {
            setLoading(false);
            if (data?.error) {
              console.log(data);
            } else {
              setLoading(false);
              setBillerInfo(data.data);
              const status = data?.data[0]?.transation_status;

              if (status == "SU") {
                window.location.href = "/success";
              } else if (status == "FA") {
                window.location.href = "/failure";
              } else {
                history.push("/processing");
                // count = count + 1;
                // if (count === 5) {
                //   swal({
                //     title: "Pending!",
                //     text: "Still Now Your Payement is Pending Now! So please Go to the home Page then you can see your payement status",
                //     icon: "warning",
                //     button: "Ok",
                //   }).then(() => {
                //     window.location.href = "/home";
                //   });
                // }
              }
            }
          });
      }
    }, 10000);
  }, []);
  const handleDownload = async (id) => {
    fetch(`${getBaseUrl}getPaymentReceiptPDF/?bill_id=${id}`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
    })
      .then((res) => res.json())
      .then((data) => {
        fileDownload(data?.file_url, data?.file_url);
      });
  };
  return (
    <Dialog
      fullScreen
      open={true}
      TransitionComponent={TransitionUp}
      className="side-pane side-pane-second"
    >
      <AppBar sx={{ position: "relative" }} className="side-pane-header">
        <div className="d-flex align-center justify-between"></div>
      </AppBar>

      <div className="row mb-5">
        <div className="col-12">
          <p className="text-center">
            <img src={Warning} className="w-50" />
          </p>
          <p className="mb-4 tx-23 text-center text-warning">
            Bill Payment Processing
          </p>
          <p className="mb-0 text-center text-black">
            To{"  "}
            {JSON.parse(localStorage.getItem("currentBankBranch"))?.billerName}
            Bank Limited
          </p>
          <p className="mb-4 text-center text-muted">CAR Loan</p>
          <div className="w-auto d-flex align-center justify-center mb-2">
            <p className="tx-23 mb-0 me-2 text-muted">&#8377;</p>
            <p className="tx-60 mb-0 me-2 text-black weight-300 lh-1">
              {amount}
            </p>
          </div>
        </div>
      </div>
      {billerInfo === undefined ? (
        <p>no data showen</p>
      ) : (
        billerInfo?.map((data) => (
          <div className="py-0 px-3">
            <div className="container-fluid">
              <p className="mb-0 text-center text-black">
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  xmlns="http://www.w3.org/2000/svg"
                  className="me-2"
                >
                  <g fill="none" fillRule="evenodd">
                    <path
                      d="M8.206 15.902a7.703 7.703 0 0 1-7.704-7.7C.502 3.947 3.952.5 8.206.5a7.703 7.703 0 0 1 7.705 7.701c0 4.253-3.45 7.701-7.705 7.701z"
                      fill="#FFA300"
                    />
                    <path
                      d="M7.506 5.401a.7.7 0 0 1 1.4 0v2.8a.7.7 0 0 1-1.4 0v-2.8zM8.206 10.302a.7.7 0 1 1 0 1.4.7.7 0 0 1 0-1.4z"
                      fill="#FFF"
                    />
                  </g>
                </svg>
                Processing | {data["transaction_date_and_time"]}
              </p>
              <div className="mt-4">
                <div className="row mb-3">
                  <div className="col-12">
                    <div className="tx-16 text-black">Receipt</div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-12">
                    <div className="d-flex align-center justify-between">
                      <p className="m-0 pe-3 text-muted">Biller name</p>
                      <p className="m-0">
                        <strong>{data?.customer_name}</strong>
                      </p>
                    </div>
                  </div>
                </div>
                <BillDetails data={data} />
                <div className="row mb-5 mt-4 pt-0">
                  <div className="col-6">
                    <button
                      type="submit"
                      className="btn btn-outline-primary w-100"
                      onClick={() => (window.location.href = "/home")}
                    >
                      Proceed to Home
                    </button>
                  </div>
                  <div className="col-6">
                    <button
                      type="submit"
                      className="btn btn-outline-primary w-100"
                      onClick={(e) => handleDownload(data?.id)}
                    >
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g fill="#412E8D" fillRule="evenodd">
                          <path d="M4.125 14.438a.687.687 0 1 1 1.375 0V16.5c0 .38.308.688.688.688h9.625c.38 0 .687-.308.687-.688v-2.063a.687.687 0 1 1 1.375 0V16.5c0 1.14-.923 2.063-2.063 2.063H6.188A2.062 2.062 0 0 1 4.124 16.5v-2.063z" />
                          <path d="M13.264 10.514a.687.687 0 1 1 .972.972l-2.75 2.75a.687.687 0 0 1-.972 0l-2.75-2.75a.687.687 0 1 1 .972-.972L11 12.778l2.264-2.264z" />
                          <path d="M10.313 4.125a.687.687 0 1 1 1.374 0v9.625a.687.687 0 1 1-1.374 0V4.125z" />
                        </g>
                      </svg>
                      Download
                    </button>
                  </div>
                </div>

                <BelowIcon />
              </div>
            </div>
          </div>
        ))
      )}
      {loading && <PeSpinner />}
    </Dialog>
  );
};

export default DomainPayEmiProcessing;
